import { Injectable } from '@angular/core';
import { AppHttpClient } from 'common/service/app-http-client.service';
import { Observable } from 'rxjs';

import { prepareApiUrl } from '../app.const';
import { ExecuteRuleService } from 'shared/execute-rule.service';

const HttpServiceMethods = {
  prepareRedirectUrl: (key: String) => prepareApiUrl(`r/${key}`),
};
@Injectable()
export class RedirectFormService {

  constructor(private httpService: AppHttpClient) { }

  public getRedirectUrl(key: string): Observable<{ fullUrl: string }> {
    return this.httpService.post(HttpServiceMethods.prepareRedirectUrl(key), null);
  }
}
